import { useMutation } from '@tanstack/react-query';
import { useDependencies } from '@servicetitan/react-ioc';
import { SetupDataStore } from '@servicetitan/financing-workflow-shared';
import {
    FinancingApi,
    AuthenticationChallengeStartRequest,
    CustomerAuthChallengeStatus,
} from '@servicetitan/financing-api-client';
import { RefObject } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';

interface UseCustomerAuthStartChallengeOptions {
    onSuccess: (challengeData: CustomerAuthChallengeStatus) => void;
    mutationKey: string[];
    recaptchaRef: RefObject<ReCAPTCHA>;
}

export const useCustomerAuthStartChallenge = ({
    onSuccess,
    mutationKey,
    recaptchaRef,
}: UseCustomerAuthStartChallengeOptions) => {
    const { setupData } = SetupDataStore.useStore();
    const [apiClient] = useDependencies(FinancingApi);

    return useMutation({
        mutationKey,
        mutationFn: async ({ phone, email }: { phone: string; email: string }) => {
            let captchaToken: string | null | undefined = '';

            if (
                window.location.hostname !== 'localhost' &&
                window.location.hostname !== '127.0.0.1'
            ) {
                recaptchaRef.current?.reset();
                captchaToken = await recaptchaRef.current?.executeAsync();
            } else {
                captchaToken = '1234'; // Solution to have local testing
            }

            const request: AuthenticationChallengeStartRequest = {
                tenantId: setupData?.tenantId,
                buId: setupData?.buId,
                captchaToken,
                phone,
                email,
            };

            return apiClient.customerAuthStartChallenge(setupData?.provider ?? '', request);
        },
        onSuccess: ({ data }: { data: CustomerAuthChallengeStatus }) => {
            onSuccess(data);
        },
    });
};
